import LiveTooltip from 'live/components/ui/tooltip'
import i18n from 'live/services/i18n' //@ts-ignore
import { restoreAllUnits, setPersistentUnits } from 'plugin-liverig/shared/asset/lib/UnitDuck' //@ts-ignore
import connectedToStoreHoc from 'plugin-liverig/shared/asset/lib/connectedToStoreHOC' //@ts-ignore
import UnitSelector from 'plugin-liverig/shared/components/UnitsSelector' //@ts-ignore
import HandsonTable from 'plugin-liverig/shared/curves/handson-table' //@ts-ignore
import RigStore from 'plugin-wells/shared/rig/store'
import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { UNITS, UNITS_FT, parameterUnits } from '../util/AlgorithmDetailsConverter'
import { ParameterKeysTypes } from './ModelsConfigTypes'
import { UnitConfig } from '../types/ConstantConfigType'

const numbroConfig = {
    type: 'numeric',
    min:0,
    numericFormat: {
        pattern: '0[.]00'
    }
}

export type UnitModel = {
    label: string
    unit: string
    initialValue: number
    value: number
    key: string
    convertedValue?: number
}

const physicalModelParameters: Record<
    ParameterKeysTypes,
    {
        label: string
        unit: string
        quantityType?: string
    }
> = {
    pipeLength: {
        label: 'Pipe Length',
        unit: UNITS.pipeLength,
        quantityType: 'depth'
    },
    standLength: {
        label: 'Stand Length',
        unit: UNITS.standLength
    },
    travellingBlockWeight: {
        label: 'Travelling Block Weight',
        unit: UNITS.travellingBlockWeight,
        quantityType: 'force'
    },
    minimumFluidFlow: {
        label: 'Minimum Fluid Flow',
        unit: UNITS.minimumFluidFlow,
        quantityType: 'volume flow rate'
    },
    minimumRotatorySpeed: {
        label: 'Minimum Rotatory Speed',
        unit: UNITS.minimumRotatorySpeed,
        quantityType: 'angle per time'
    },
    minimumWeightOnBit: {
        label: 'Minimum Weight On Bit',
        unit: UNITS.minimumWeightOnBit,
        quantityType: 'force'
    },
    minimumTorque: {
        label: 'Minimum Torque',
        unit: UNITS.minimumTorque,
        quantityType: 'torque'
    },
    minimumStandpipePressure: {
        label: 'Minimum Standpipe Pressure',
        unit: UNITS.minimumStandpipePressure,
        quantityType: 'pressure'
    },
    blockWeight: {
        label: 'Block Weight',
        unit: UNITS.blockWeight
    },
    minimumRateOfPenetration: {
        label: 'Minimum Rate Of Penetration',
        unit: UNITS.minimumRateOfPenetration,
        quantityType: 'velocity'
    },
    bottomDepthTolerance: {
        label: 'Bottom Depth Tolerance',
        unit: UNITS.bottomDepthTolerance,
        quantityType: 'depth'
    },
    movementThreshold: {
        label: 'Movement Threshold',
        unit: UNITS.movementThreshold,
        quantityType: 'depth'
    },
    blockWeightToleranceThreshold: {
        label: 'Block Weight Tolerance Threshold',
        unit: '-'
    },

    hookLoadRatioThreshold: {
        label: 'Hook Load Ratio Threshold',
        unit: '-'
    },
    connectionTimeout: {
        label: 'Connection Timeout',
        unit: UNITS.connectionTimeout,
        quantityType: 'time'
    },
    timeout: {
        label: 'Timeout',
        unit: UNITS.timeout,
        quantityType: 'time'
    },
    minimumOperationDuration: {
        label: 'Minimum Operation Duration',
        unit: UNITS.minimumOperationDuration,
        quantityType: 'time'
    },
    maximumTimeToDetectRevertConnection: {
        label: 'Maximum Time To Detect Revert Connection',
        unit: UNITS.maximumTimeToDetectRevertConnection
    },
    maxQueuePeriod: {
        label: 'Max Queue Period',
        unit: UNITS.maxQueuePeriod
    },
    minQueuePeriod: {
        label: 'min Queue Period',
        unit: UNITS.minQueuePeriod
    },
    minimumDrillStringRotarySpeed: {
        label: 'Minimum Drill String Rotary Speed',
        unit: UNITS.minimumDrillStringRotarySpeed
    },

    lowBitDepthThreshold: {
        label: 'Low Bit Depth Threshold',
        unit: UNITS.lowBitDepthThreshold,
        quantityType: 'depth'
    },
    dataPeriod: {
        label: 'Data Period',
        unit: UNITS.dataPeriod,
        quantityType: 'time'
    },
    minimumSpeed: {
        label: 'Minimum Speed',
        unit: UNITS.minimumSpeed,
        quantityType: 'velocity'
    },
    enableSSAFiltering: {
        label: 'Enable SSA Filtering',
        unit: UNITS.enableSSAFiltering
    },
    hookLoadWithoutBlockWeight: {
        label: 'Hook Load Without Block Weight',
        unit: UNITS.hookLoadWithoutBlockWeight
    }
}

const physicalModelParameters_ft: Record<
    ParameterKeysTypes,
    {
        label: string
        unit: string
        quantityType?: string
    }
> = {
    pipeLength: {
        label: 'Pipe Length',
        unit: UNITS_FT.pipeLength,
        quantityType: 'depth'
    },
    standLength: {
        label: 'Stand Length',
        unit: UNITS_FT.standLength
    },
    travellingBlockWeight: {
        label: 'Travelling Block Weight',
        unit: UNITS_FT.travellingBlockWeight,
        quantityType: 'force'
    },
    minimumFluidFlow: {
        label: 'Minimum Fluid Flow',
        unit: UNITS_FT.minimumFluidFlow,
        quantityType: 'volume flow rate'
    },
    minimumRotatorySpeed: {
        label: 'Minimum Rotatory Speed',
        unit: UNITS_FT.minimumRotatorySpeed,
        quantityType: 'angle per time'
    },
    minimumWeightOnBit: {
        label: 'Minimum Weight On Bit',
        unit: UNITS_FT.minimumWeightOnBit,
        quantityType: 'force'
    },
    minimumTorque: {
        label: 'Minimum Torque',
        unit: UNITS_FT.minimumTorque,
        quantityType: 'torque'
    },
    minimumStandpipePressure: {
        label: 'Minimum Standpipe Pressure',
        unit: UNITS_FT.minimumStandpipePressure,
        quantityType: 'pressure'
    },
    blockWeight: {
        label: 'Block Weight',
        unit: UNITS_FT.blockWeight
    },
    minimumRateOfPenetration: {
        label: 'Minimum Rate Of Penetration',
        unit: UNITS_FT.minimumRateOfPenetration,
        quantityType: 'velocity'
    },
    bottomDepthTolerance: {
        label: 'Bottom Depth Tolerance',
        unit: UNITS_FT.bottomDepthTolerance,
        quantityType: 'depth'
    },
    movementThreshold: {
        label: 'Movement Threshold',
        unit: UNITS_FT.movementThreshold,
        quantityType: 'depth'
    },
    blockWeightToleranceThreshold: {
        label: 'Block Weight Tolerance Threshold',
        unit: '-'
    },

    hookLoadRatioThreshold: {
        label: 'Hook Load Ratio Threshold',
        unit: '-'
    },
    connectionTimeout: {
        label: 'Connection Timeout',
        unit: UNITS_FT.connectionTimeout,
        quantityType: 'time'
    },
    timeout: {
        label: 'Timeout',
        unit: UNITS_FT.timeout,
        quantityType: 'time'
    },
    minimumOperationDuration: {
        label: 'Minimum Operation Duration',
        unit: UNITS_FT.minimumOperationDuration,
        quantityType: 'time'
    },
    maximumTimeToDetectRevertConnection: {
        label: 'Maximum Time To Detect Revert Connection',
        unit: UNITS_FT.maximumTimeToDetectRevertConnection
    },
    maxQueuePeriod: {
        label: 'Max Queue Period',
        unit: UNITS_FT.maxQueuePeriod
    },
    minQueuePeriod: {
        label: 'min Queue Period',
        unit: UNITS_FT.minQueuePeriod
    },
    minimumDrillStringRotarySpeed: {
        label: 'Minimum Drill String Rotary Speed',
        unit: UNITS_FT.minimumDrillStringRotarySpeed
    },

    lowBitDepthThreshold: {
        label: 'Low Bit Depth Threshold',
        unit: UNITS_FT.lowBitDepthThreshold,
        quantityType: 'depth'
    },
    dataPeriod: {
        label: 'Data Period',
        unit: UNITS_FT.dataPeriod,
        quantityType: 'time'
    },
    minimumSpeed: {
        label: 'Minimum Speed',
        unit: UNITS_FT.minimumSpeed,
        quantityType: 'velocity'
    },
    enableSSAFiltering: {
        label: 'Enable SSA Filtering',
        unit: UNITS_FT.enableSSAFiltering
    },
    hookLoadWithoutBlockWeight: {
        label: 'Hook Load Without Block Weight',
        unit: UNITS_FT.hookLoadWithoutBlockWeight
    }
}

export const getPhysicalModelParameters = (unitConfig: UnitConfig) => {
    return {
        pipeLength: {
            label: 'Pipe Length',
            unit: parameterUnits[unitConfig].pipeLength,
            quantityType: 'depth'
        },
        standLength: {
            label: 'Stand Length',
            unit: parameterUnits[unitConfig].standLength
        },
        travellingBlockWeight: {
            label: 'Travelling Block Weight',
            unit: parameterUnits[unitConfig].travellingBlockWeight,
            quantityType: 'force'
        },
        minimumFluidFlow: {
            label: 'Minimum Fluid Flow',
            unit: parameterUnits[unitConfig].minimumFluidFlow,
            quantityType: 'volume flow rate'
        },
        minimumRotatorySpeed: {
            label: 'Minimum Rotatory Speed',
            unit: parameterUnits[unitConfig].minimumRotatorySpeed,
            quantityType: 'angle per time'
        },
        minimumWeightOnBit: {
            label: 'Minimum Weight On Bit',
            unit: parameterUnits[unitConfig].minimumWeightOnBit,
            quantityType: 'force'
        },
        minimumTorque: {
            label: 'Minimum Torque',
            unit: parameterUnits[unitConfig].minimumTorque,
            quantityType: 'torque'
        },
        minimumStandpipePressure: {
            label: 'Minimum Standpipe Pressure',
            unit: parameterUnits[unitConfig].minimumStandpipePressure,
            quantityType: 'pressure'
        },
        blockWeight: {
            label: 'Block Weight',
            unit: parameterUnits[unitConfig].blockWeight
        },
        minimumRateOfPenetration: {
            label: 'Minimum Rate Of Penetration',
            unit: parameterUnits[unitConfig].minimumRateOfPenetration,
            quantityType: 'velocity'
        },
        bottomDepthTolerance: {
            label: 'Bottom Depth Tolerance',
            unit: parameterUnits[unitConfig].bottomDepthTolerance,
            quantityType: 'depth'
        },
        movementThreshold: {
            label: 'Movement Threshold',
            unit: parameterUnits[unitConfig].movementThreshold,
            quantityType: 'depth'
        },
        blockWeightToleranceThreshold: {
            label: 'Block Weight Tolerance Threshold',
            unit: '-'
        },

        hookLoadRatioThreshold: {
            label: 'Hook Load Ratio Threshold',
            unit: '-'
        },
        connectionTimeout: {
            label: 'Connection Timeout',
            unit: parameterUnits[unitConfig].connectionTimeout,
            quantityType: 'time'
        },
        timeout: {
            label: 'Timeout',
            unit: parameterUnits[unitConfig].timeout,
            quantityType: 'time'
        },
        minimumOperationDuration: {
            label: 'Minimum Operation Duration',
            unit: parameterUnits[unitConfig].minimumOperationDuration,
            quantityType: 'time'
        },
        maximumTimeToDetectRevertConnection: {
            label: 'Maximum Time To Detect Revert Connection',
            unit: parameterUnits[unitConfig].maximumTimeToDetectRevertConnection
        },
        maxQueuePeriod: {
            label: 'Max Queue Period',
            unit: parameterUnits[unitConfig].maxQueuePeriod
        },
        minQueuePeriod: {
            label: 'min Queue Period',
            unit: parameterUnits[unitConfig].minQueuePeriod
        },
        minimumDrillStringRotarySpeed: {
            label: 'Minimum Drill String Rotary Speed',
            unit: parameterUnits[unitConfig].minimumDrillStringRotarySpeed
        },

        lowBitDepthThreshold: {
            label: 'Low Bit Depth Threshold',
            unit: parameterUnits[unitConfig].lowBitDepthThreshold,
            quantityType: 'depth'
        },
        dataPeriod: {
            label: 'Data Period',
            unit: parameterUnits[unitConfig].dataPeriod,
            quantityType: 'time'
        },
        minimumSpeed: {
            label: 'Minimum Speed',
            unit: parameterUnits[unitConfig].minimumSpeed,
            quantityType: 'velocity'
        },
        enableSSAFiltering: {
            label: 'Enable SSA Filtering',
            unit: parameterUnits[unitConfig].enableSSAFiltering
        },
        hookLoadWithoutBlockWeight: {
            label: 'Hook Load Without Block Weight',
            unit: parameterUnits[unitConfig].hookLoadWithoutBlockWeight
        }
    }
}
const fieldsArrayData = Object.values(physicalModelParameters) as Array<{
    readOnly: boolean
    label: string
    unit: string
    tooltipText: string
    quantityType: string
}>

const ContentTooltipText = styled.div`
    a {
        font-size: 11px;
        margin-left: 10px;
    }
`
const tooltipRender = (
    hotInstance: HandsonTable,
    td: HTMLElement,
    row: number,
    column: number,
    prop: string,
    value: string,
    cellProperties: Record<string, any>
) => {
    if (fieldsArrayData[row]?.tooltipText) {
        ReactDOM.render(
            <ContentTooltipText>
                <span>{value} </span>
                <LiveTooltip position="top" content={fieldsArrayData[row]?.tooltipText}>
                    <a>
                        <i className="fa fa-question-circle-o"></i>
                    </a>
                </LiveTooltip>
            </ContentTooltipText>,
            td
        )
        td.style.position = 'relative'
    } else {
        td.innerHTML = value
    }

    return td
}

const fieldsKeys = Object.keys(physicalModelParameters)

const definePhysicalModelSettings = (
    readOnly: boolean,
    setChanged: Function,
    modelParametersPlaceholders: Array<UnitModel>
) => {
    return {
        readOnly: readOnly,
        beforeKeyDown: function(e) {
            const reg = /^\d+$/
            const col = this.getSelectedLast()[1]

            if (col === 2) {
                if (!reg.test(e.key) && e.key !== 'Backspace' && e.key !== '.' && e.key !== ',') {
                    e.preventDefault()
                }
            }
        },
        columns: [
            {
                data: 'label',
                type: 'text',
                readOnly: true,
                editor: false,
                renderer: tooltipRender
            },
            {
                data: 'unit',
                type: 'text',
                readOnly: true,
                renderer: (instance, td, row, col, prop, value, cellProperties) => {
                    if (fieldsArrayData[row].quantityType) {
                        ReactDOM.hydrate(
                            <ConnectedUnitSelector
                                unitGroup="MODELS"
                                section="physicalModels"
                                unitKey={fieldsKeys[row]}
                                quantityType={fieldsArrayData[row].quantityType}
                                readOnly={true}
                                hideParenthesis={true}
                                setChanged={() => setChanged(true)}
                            />,
                            td
                        )
                    } else {
                        td.innerHTML = fieldsArrayData[row]?.unit
                    }

                    return td
                }
            },
            {
                data: 'defaultValue',
                type: 'text',
                readOnly: true,
                editor: false,
                renderer: tooltipRender
            },
            {
                data: 'value',
                type: 'numeric',
                ...numbroConfig,
                renderer: (instance, td, row, col, prop, value, cellProperties) => {
                    if (!value) {
                        td.style.color = 'rgba(153, 153, 153, 0.7)'
                        if (Array.isArray(modelParametersPlaceholders)) {
                            let value = modelParametersPlaceholders?.[row]?.initialValue.toString()
                            if (modelParametersPlaceholders?.[row]?.convertedValue) {
                                value = modelParametersPlaceholders?.[row]?.convertedValue.toFixed(8)
                            }
                            td.innerHTML = value || '-'
                        }
                    } else {
                        td.innerHTML = value
                    }
                    if (fieldsArrayData[row]?.readOnly) {
                        td.style.background = 'var(--gray-200)'
                        td.style['pointer-events'] = 'none'
                        td.style.cursor = 'auto'
                    }

                    return td
                }
            }
        ],
        get colHeaders() {
            return [i18n('Parameter'), i18n('Unit'), i18n('default value'), i18n('Specified value')]
        },
        colWidths: [40, 10, 20, 80],
        width: '100%'
    }
}

const mapStateToProps = ({ unit }) => ({
    unitsPhysicalModels: unit?.physicalModels
})
const ConnectedUnitSelector = connectedToStoreHoc(
    connect(mapStateToProps, { restoreAllUnits, setPersistentUnits })(UnitSelector),
    RigStore
)

const ModelsConstants = {
    definePhysicalModelSettings,
    physicalModelParameters,
    physicalModelParameters_ft
}
export default ModelsConstants
